// import React from "react";
import PropTypes from "prop-types";

export default function FlipImage({ imgObj }) {
  return (
    <section data-aos="zoom-out-up" className="chwckout_exp mt-5">
      <div className="px-lg-3 px-2">
        <div className={`row lopdjk pop_flip`}>
          <div className="col-lg-3 col-3 mb-lg-3 px-lg-2 px-1">
            <div className="flip-container auto-flip">
              <div className="flipper">
                <div className="front">
                  <img loading="lazy" src={imgObj?.imgf1} alt="POS system" />
                </div>
                <div className="back">
                  <img loading="lazy" src={imgObj?.imgb1} alt="POS system" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-3 mb-lg-3 px-lg-2 px-1">
            <div className="row h-100">
              <div className="col-lg-12 mb-lg-3 mb-2">
                <div className="flip-container auto-flip">
                  <div className="flipper">
                    <div className="front">
                      <img
                        loading="lazy"
                        src={imgObj?.imgf2}
                        alt="POS software"
                      />
                    </div>
                    <div className="back">
                      <img
                        loading="lazy"
                        src={imgObj?.imgb2}
                        alt="POS software"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 ">
                <div className="flip-container auto-flip">
                  <div className="flipper">
                    <div className="front">
                      <img
                        loading="lazy"
                        src={imgObj?.imgf3}
                        alt="Contactless payment for shop"
                      />
                    </div>
                    <div className="back">
                      <img
                        loading="lazy"
                        src={imgObj?.imgb3}
                        alt="Contactless payment for shop"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-3 mb-lg-3 px-lg-2 px-1">
            <div className="flip-container auto-flip">
              <div className="flipper">
                <div className="front">
                  <img
                    loading="lazy"
                    src={imgObj?.imgf4}
                    alt="POS with real-time inventory"
                  />
                </div>
                <div className="back">
                  <img
                    loading="lazy"
                    src={imgObj?.imgb4}
                    alt="POS with real-time inventory"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-3 mb-lg-3 px-lg-2 px-1">
            <div className="flip-container auto-flip">
              <div className="flipper">
                <div className="front">
                  <img
                    loading="lazy"
                    src={imgObj?.imgf5}
                    alt="Fusion POS for small businesses"
                  />
                </div>
                <div className="back">
                  <img
                    loading="lazy"
                    src={imgObj?.imgb5}
                    alt="Fusion POS for small businesses"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

FlipImage.propTypes = {
  imgObj: PropTypes.object,
};
